<div mat-dialog-title class="dialog-header">
    <button type="button" class="close-button" (click)="onNoClick()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
    <h4>Operational Fields Aliases</h4>
  </div>
  
  <mat-divider></mat-divider>
  
  <div mat-dialog-content style="margin-top: 20px;margin-bottom: 20px">
    <!-- <div *ngFor="let item of filters">
      <span style="font-size:18px;font-weight: 500;">{{item}}</span>
    </div> -->
    <div *ngFor="let cf of customFields;let i = index" style="margin-top:15px">
          <span *ngIf="cf.alias">{{cf.value}} ({{cf.key}}) - {{cf.alias}} <span *ngIf="isSurvaleAdmin"> [ {{cf.hash}} ]</span>
            <button mat-raised-button mat-primary class="delete-button" (click)="removeAliases(cf,i)">
                <i class="fa fa-trash"></i></button>
          </span>
    </div>
  </div>
